import SublimeMedia from '@components/common/SublimeMedia/SublimeMedia'
import Image from 'next/image'
import { useState } from 'react'
import styles from './SwiperBook.module.scss'

const SwiperBookLayers = ({ chapter, page, pageRef }: any) => {
  const [load, setLoad] = useState<boolean>(false)
  return (
    <div
      className="Layers"
      data-index={page.pageNumber - 1}
      ref={pageRef}
      data-chapter-id={chapter.chapterID}
      data-chapter-title={chapter.chapterTitle}
    >
      {page.layers.map((layer: any, indexKey: number) => (
        <div
          className={`Layer Layer--${layer.layerType} ${styles.Layer}`}
          key={indexKey}
          style={{ zIndex: indexKey }}
          data-layer-type={layer.layerType}
          data-layer-zoom={layer.zoomAnimationImageLayer}
        >
          {layer.layerType === 'video' && (
            <SublimeMedia
              mediaPicker={layer.mediaPicker}
              width={1920}
              height={1280}
              data-src={layer?.mediaPicker?.url || ''}
            />
          )}
          {layer?.mediaPicker && layer.layerType === 'image' && (
            <SublimeMedia
              mediaPicker={layer.mediaPicker}
              width={1920}
              height={1280}
              data-src={layer?.mediaPicker?.url || ''}
            />
          )}

          {layer.layerType === 'graphics' && (
            <SublimeMedia
              mediaPicker={layer.mediaPicker}
              width={1920}
              height={1280}
              data-src={layer?.mediaPicker?.url || ''}
            />
          )}

          {layer?.mediaPicker && layer.layerType === 'svg' && (
            <Image
              className="slider-lazy"
              alt=""
              src={layer?.mediaPicker?.url || ''}
              data-src={layer?.mediaPicker?.url || ''}
              width={1920}
              height={1280}
            />
          )}
        </div>
      ))}
    </div>
  )
}

export default SwiperBookLayers
